module.exports = __webpack_public_path__ + "img/ic_warning.60d5444a.svg";